<template>
    <v-container fluid style="height: 100%; overflow: auto">
        <ImageSlider></ImageSlider>
        <div style="width: 100%" class="column align-center">
            <div id="infomation" class="row screen-width">
                <router-link
                    v-for="(infomation, index) in info_list"
                    :key="index"
                    style="width: 288px; color: black"
                    :to="infomation.path"
                >
                    <service-button
                        :imageSrc="infomation.src"
                        :textTitle="infomation.title"
                        :textDetail="infomation.detail"
                        :onClick="{}"
                    ></service-button
                ></router-link>
            </div>

            <!-- 문제해결 제품 -->
            <div id="product" class="align-center column">
                <p
                    style="
                        font-size: 36px;
                        font-weight: bold;
                        margin-bottom: 16px;
                    "
                >
                    궁금하신 제품을 선택하세요
                </p>
                <div id="product-list" class="row screen-width">
                    <router-link
                        v-for="(product, index) in productList_part"
                        :key="index"
                        class="align-center"
                        style="width: 20%; height: 200px; color: black"
                        :to="product.path"
                    >
                        <image-text-button
                            :imageSrc="product.src"
                            :textContent="product.content"
                            :textStyle="{
                                fontSize: '16px',
                            }"
                            :imageTextGap="8"
                        ></image-text-button>
                    </router-link>
                </div>
                <!-- <div id="product-list" class="row">
                    <div
                        v-for="product in productList_part2"
                        :key="product"
                        class="align-center"
                        style="width: 256px; height: 100%"
                    >
                        <image-text-button
                            :imageSrc="product.src"
                            :textContent="product.content"
                            :textStyle="{
                                fontSize: '16px',
                            }"
                            :imageTextGap="8"
                        ></image-text-button>
                    </div>
                </div> -->
            </div>

            <!-- 검색 -->
            <div id="search" class="align-center column screen-width">
                <p
                    style="
                        font-size: 36px;
                        font-weight: bold;
                        margin-bottom: 12px;
                    "
                >
                    제품정보, 증상을 검색해보세요
                </p>
                <search-bar
                    style="margin-bottom: 12px"
                    v-on:onSearch="goIntegratedSearch"
                ></search-bar>
                <div class="row align-space-between" style="min-width: 600px">
                    <!-- <a class="search-tag"> #플로터 기능 </a>
                    <a class="search-tag"> #플로터 기능 </a>
                    <a class="search-tag"> #플로터 기능 </a>
                    <a class="search-tag"> #플로터 기능 </a> -->
                </div>
            </div>

            <!-- 주요 서비스 -->
            <div id="service" class="align-center column">
                <p
                    style="
                        font-size: 36px;
                        font-weight: bold;
                        margin-bottom: 20px;
                    "
                >
                    고객 서비스
                </p>
                <div class="row">
                    <div
                        v-for="(service, index) in service_list"
                        :key="index"
                        class="align-center"
                        style="width: 256px; height: 100%"
                        :style="{
                            borderLeft:
                                index !== 0 ? '1px solid #dddddd' : 'none',
                        }"
                    >
                        <image-text-button
                            :imageSrc="service.src"
                            :textContent="service.content"
                            :textStyle="{
                                fontSize: '28px',
                                fontWeight: 'bold',
                            }"
                            :imageSize="184"
                            :imageTextGap="20"
                            @click="movePage(service.path)"
                        ></image-text-button>
                    </div>
                </div>
            </div>
            <div
                class="align-center column screen-width"
                style="height: 140px; margin-bottom: 20px"
            >
                <v-img :src="partner_company" width="100%" height="140px">
                </v-img>
            </div>
        </div>
    </v-container>
</template>

<script>
import { ref } from "vue";
// import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ImageSlider from "@/components/ImageSlider.vue";
import ServiceButton from "@/components/ServiceButton.vue";
import ImageTextButton from "@/components/ImageTextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import partner_company from "@/assets/img/partner_company.avif";
const info_list = ref([
    {
        src: require("@/assets/img/video.avif"),
        title: "동영상",
        detail: "동영상을 활용하여 궁금증을 해결하세요",
        path: "/data/video",
    },
    {
        src: require("@/assets/img/download.avif"),
        title: "다운로드",
        detail: "필요한 소프트웨어나 가이드를 받아가세요",
        path: "/data/download",
    },
    {
        src: require("@/assets/img/qna.avif"),
        title: "질문과 답변",
        detail: "해결하지 못한 궁금증을 풀어보세요",
        path: "/customer/qna",
    },
    {
        src: require("@/assets/img/notice.avif"),
        title: "공지사항",
        detail: "새로운 소식을 접해보세요",
        path: "/notice",
    },
]);

const productList_part = ref([
    {
        src: require("@/assets/img/gpsplotter.avif"),
        content: "GPS플로터",
        path: {
            path: "/problem",
            query: { category: "GPS플로터" },
        },
    },
    {
        src: require("@/assets/img/radar.avif"),
        content: "레이더",
        path: {
            path: "/problem",
            query: { category: "레이더" },
        },
    },
    {
        src: require("@/assets/img/wirelessconnect.avif"),
        content: "무선/통신장비",
        path: {
            path: "/problem",
            query: { category: "무선/통신장비" },
        },
    },
    {
        src: require("@/assets/img/safety.avif"),
        content: "항해안전장비",
        path: {
            path: "/problem",
            query: { category: "항해 안전장비" },
        },
    },
    {
        src: require("@/assets/img/navigation.avif"),
        content: "항해조타장비",
        path: {
            path: "/problem",
            query: { category: "항해 조타장비" },
        },
    },

    {
        src: require("@/assets/img/antena.avif"),
        content: "안테나/헤딩센서",
        path: {
            path: "/problem",
            query: { category: "해상용 안테나/헤딩센서" },
        },
    },
    {
        src: require("@/assets/img/battery.avif"),
        content: "인산철배터리",
        path: {
            path: "/problem",
            query: { category: "선박용 인산철배터리" },
        },
    },
    {
        src: require("@/assets/img/electronic.avif"),
        content: "전기관련 제품",
        path: {
            path: "/problem",
            query: { category: "선박용 전기관련 제품" },
        },
    },
    {
        src: require("@/assets/img/accessory.avif"),
        content: "부품/액세서리",
        path: {
            path: "/problem",
            query: { category: "부품 및 액세서리" },
        },
    },
    {
        src: require("@/assets/img/discontinued.avif"),
        content: "단종제품",
        path: {
            name: "Problem",
            params: { category: "단종제품" },
        },
    },
]);

const service_list = ref([
    {
        src: require("@/assets/img/assubmit.avif"),
        path: "/service/submit",
        content: "AS접수신청",
    },
    {
        src: require("@/assets/img/lecture.avif"),
        path: "/service/lecture",
        content: "교육 신청",
    },
    {
        src: require("@/assets/img/check.avif"),
        path: "/service/check",
        content: "접수 조회",
    },
    {
        src: require("@/assets/img/shop.avif"),
        path: "/shop",
        content: "소모품샵",
    },
]);

export default {
    name: "home-layout",
    components: {
        ImageSlider,
        ServiceButton,
        ImageTextButton,
        SearchBar,
    },
    setup() {
        const router = useRouter();
        // onMounted(() => {
        //     // store.dispatch("getProductList");
        // });

        const movePage = (path) => {
            router.push(path);
        };

        const goIntegratedSearch = (search) => {
            router.push({
                path: "/search",
                query: { search: search },
            });
        };

        return {
            info_list,
            productList_part,
            service_list,
            partner_company,
            movePage,
            goIntegratedSearch,
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

#infomation {
    margin: 56px auto;
    padding: 20px;
    justify-content: space-between;
}

#product {
    width: 100%;
    height: auto;
    background: #f4f4f4;
    padding: 56px;
}

#product-list {
    height: auto;
    flex-wrap: wrap;
}

#search {
    height: 276px;
    padding: 53px 0px 0px 0px;
}

#service {
    width: 100%;
    height: 474px;
    padding: 56px 0px;
}
</style>
